module.exports = __webpack_public_path__ + "static/media/wood-shield.9fc346d9.png";